import { Component, ojs, app } from "modular-openscriptjs";
import { either, eParse, tab } from "../../helpers";
import { dom } from "../../fotastart";
import { PAGES } from "../../declarations";
import { api } from "../../declarations";
import { routes } from "../../backendRoutes";
import FeedProductsHolder from "../FeedProductsHolder";

const h = app("h");
const $e = app("$e");

ojs(FeedProductsHolder);

export default class FeedPage extends Component {
	feeds = null;
	map = null;
	pageMap = null;

	activeTab = "all";

	initMaps() {
		if (this.feeds == null) this.feeds = {};
		if (this.map == null)
			this.map = { all: {}, business: {}, following: {} };
		if (this.pageMap == null)
			this.pageMap = { all: 0, business: 0, following: 0 };
	}

	render(...args) {
		pageInfo(PAGES.FEED);

		this.initMaps();

		return h.div(
			{
				class: "py-md-5 mx-auto py-md-5 w-100 w-md-50",
				style: "max-width: 500px;",
			},
			h.Tabs(
				{
					holders: {
						nav: h.div({
							class: "bg-white justify-content-center mb-3 mx-auto nav nav-pills border rounded-pill sticky-top",
							style: "max-width: fit-content; top: 60px;",
						}),
						body: h.div({ class: "tab-content pt-3" }),
					},
					tabs: [
						tab(
							h.button(
								{
									class: "nav-link btn btn-primary rounded-pill",
									listeners: {
										click: () => (this.activeTab = "all"),
									},
								},
								"All",
								either(this.activeTab == "all", {
									class: "active",
								})
							),
							h.div(
								{ class: "tab-pane fade" },
								either(this.activeTab == "all", {
									class: "show active",
								}),
								h.InfiniteScroll({
									child: h.FeedProductsHolder({
										id: `c-feed-products-all`,
									}),
									callback: (entries, observer, marker) => {
										entries.forEach((entry) => {
											if (!entry.isIntersecting) return;
											this.getFeed(
												marker,
												`c-feed-products-all`,
												"all"
											);
										});
									},
								})
							)
						),
						tab(
							h.button(
								{
									class: "nav-link btn btn-primary rounded-pill",
									listeners: {
										click: () =>
											(this.activeTab = "business"),
									},
								},
								"Businesses",
								either(this.activeTab == "business", {
									class: "active",
								})
							),
							h.div(
								{ class: "tab-pane fade" },
								either(this.activeTab == "business", {
									class: "show active",
								}),
								h.InfiniteScroll({
									child: h.FeedProductsHolder({
										id: `c-feed-products-business`,
									}),
									callback: (entries, observer, marker) => {
										entries.forEach((entry) => {
											if (!entry.isIntersecting) return;
											this.getFeed(
												marker,
												`c-feed-products-business`,
												"business"
											);
										});
									},
								})
							)
						),
						tab(
							h.button(
								{
									class: "nav-link btn btn-primary rounded-pill",
									listeners: {
										click: () =>
											(this.activeTab = "following"),
									},
								},
								"Following",
								either(this.activeTab == "following", {
									class: "active",
								})
							),
							h.div(
								{ class: "tab-pane fade" },
								either(this.activeTab == "following", {
									class: "show active",
								}),
								h.InfiniteScroll({
									child: h.FeedProductsHolder({
										id: `c-feed-products-following`,
									}),
									callback: (entries, observer, marker) => {
										entries.forEach((entry) => {
											if (!entry.isIntersecting) return;
											this.getFeed(
												marker,
												`c-feed-products-following`,
												"following"
											);
										});
									},
								})
							)
						),
					],
				},
				{ $class: "mb-3" }
			),

			h.Fab([
				h.SearchIconBtn({ class: "bg-white" }),
				h.button(
					{
						class: "btn btn-dark",
						onclick: h.func("fireEvent", $e.app.needs.orderOptions),
					},
					h.i({ class: "fa-solid fa-pen" })
				),
			]),
			...args
		);
	}

	async getFeed(marker, holderId, filter) {
		this.pageMap[filter]++;

		let page = this.pageMap[filter];

		let spinner = h.Spinner({
			class: "p-3",
			parent: marker,
			resetParent: true,
		});

		let res = await api.get(`${routes.users}/feed/${filter}`, {
			page,
		});

		if (res) {
			let products = res.data.feed;

			for (let product of products) {
				let id = `p-${product?.id}`;
				let rendered = false;

				if (dom.get(`[feed-product-id="${id}"]`, dom.id(holderId))) {
					rendered = true;
				}

				let component =
					product?.item_type == "errand"
						? "MainErrandView"
						: "MainProductView";

				if (!rendered) {
					h[component](product, {
						class: "bg-white  p-3 rounded mb-3 border",
						parent: dom.id(holderId),
						$feed_product_id: id,
					});
				}
			}

			if (!products?.length && this.pageMap[filter] == 1) {
				h.div(
					{
						parent: dom.id(holderId),
						resetParent: true,
						class: "text-secondary fst-italic text-center",
						id: "vp-no-item-found",
					},
					"You're all caught up"
				);
			}

			if (!products?.length) this.pageMap[filter] = page - 1;
			else {
				dom.id("vp-no-item-found")?.remove();
				this.pageMap[filter] = res.data.page;
			}
		}

		spinner.remove();
	}

	$$ojs = {
		beforeRouteChange: () => {
			this.cleanUp();
		},
	};

	cleanUp() {
		super.cleanUp();

		this.feeds = null;
		this.map = null;
		this.pageMap = null;
	}

	updateProducts(ed, event) {
		if (this.feeds == null) return;

		const { message } = eParse(ed);
		const product = message.get("product");
		let id = `p-${product.id}`;

		let component =
			product?.item_type == "errand"
				? "MainErrandView"
				: "MainProductView";

		if (message.get("action") == "add_product" && !product?.is_private) {
			h[component](product, {
				firstOfParent: true,
				class: "bg-white  p-3 rounded mb-3 border",
				parent: dom.id("c-feed-products-all"),
				$feed_product_id: id,
			});

			return;
		}

		for (let filter in ["all", "business", "following"]) {
			let holderId = `c-feed-products-${filter}`;

			if (event == $e.product.deleted || product?.is_private == 1) {
				dom.get(
					`[feed-product-id="${id}"]`,
					dom.id(holderId)
				)?.remove();
			} else {
				if (dom.get(`[feed-product-id="${id}"]`, dom.id(holderId))) {
					h[component](product, {
						replaceParent: true,
						class: "bg-white  p-3 rounded mb-3 border",
						parent: dom.get(
							`[feed-product-id="${id}"]`,
							dom.id(holderId)
						),
						$feed_product_id: id,
					});
				}
			}
		}
	}

	$$product = {
		stored_deleted: (ed, event) => this.updateProducts(ed, event),
		is: {
			liked_unliked_bookmarked_notBookmarked_commented: (ed, event) => {
				this.updateProducts(ed, event);
			},
		},
	};
}

ojs(FeedPage);
